<template>
  <div v-if="config">
    <customNavbar class="overflow-hidden" />
    <b-container fluid>
      <router-view :key="key" />
    </b-container>
    <customFooter />
    <notifications group="notify-group" width="350" position="top center" style="top: 84px;" />
  </div>
</template>

<script>
import CustomNavbar from "@/layout/CustomNavbar";
import CustomFooter from "@/layout/CustomFooter";
export default {
  name: "customLayout",
  components: {
    CustomNavbar,
    CustomFooter
  },
  data() {
    return {};
  },
  watch: {
    "config.backgroundColor": function(val) {
      document.body.style.background = val;
    }
  },

  mounted() {
    this.$store.dispatch("downloadLayout", this.companyName);
  },

  computed: {
    companyName: function() {
      return this.$route.params.companyName;
    },
    config: function() {
      return this.$store.getters.layoutConfig;
    },
    key: function() {
      return this.$store.getters.getKey;
    }
  }
};
</script>

<style>
.overflow-hidden {
  overflow: hidden;
}
.container-fluid {
  margin-bottom: 100px !important;
}
.container {
  margin-bottom: 100px !important;
}
</style>
